<template>
	<div>
		<transition name="van-slide-up">
			<div class="modal" v-if="show">
				<div class="modal-content">
					<ul>
						<li @click="$router.push('/post/zufang');show=false">
							<img src="../../assets/images/index-4.png" />
							<br />租房
						</li>
						<li @click="$router.push('/post/ershoufang');show=false">
							<img src="../../assets/images/index-2.png" />
							<br />二手房
						</li>
						<li @click="$router.push('/post/shop');show=false">
							<img src="../../assets/images/index-7.png" />
							<br />商铺
						</li>
						<li @click="$router.push('/post/jingjiren');show=false">
							<img src="../../assets/images/index-8.png" />
							<br />委托卖房
						</li>
					</ul>
					<van-icon name="close" size="30" @click="show=false" />
				</div>
			</div>
		</transition>
		<div style="height:75px"></div>
		<div class="footmenu">
			<ul>
				<li>
					<van-icon name="home-o" size="20" @click="$router.push('/')" />首页
				</li>
				<li>
					<div class="plus" @click="send">
						<van-icon name="plus" size="24" />
					</div>
					<div class="plus-txt">发布房源</div>
				</li>
				<li>
					<van-icon name="manager-o" @click="check" size="20" />我的
				</li>
			</ul>
		</div>
		<!-- <div class="ai-boot"  @click="$router.push('/ai')">
			<img src="../../assets/images/20250626163641.png" />
		</div> -->
	</div>
</template>

<script>
	var root = process.env.VUE_APP_API_URL;
	import {
		Button,
		Tabbar,
		TabbarItem,
		Popup,
		Toast,
		Icon
	} from "vant";

	export default {
		components: {
			[Button.name]: Button,
			[Tabbar.name]: Tabbar,
			[TabbarItem.name]: TabbarItem,
			[Popup.name]: Popup,
			[Toast.name]: Toast,
			[Icon.name]: Icon
		},

		data() {
			return {
				show: false,
				getInitUrl: root + "user/index",

				active: "home"
			};
		},
		props: {},
		mounted() {},

		methods: {
			send() {
				var storage = window.localStorage;
				if (storage.getItem("accessToken")) {
					this.show = true;
				} else {
					this.$router.push("/login");
				}
				//检查是不是黑名单企业
			},
			check() {
				var self = this;
				$.ajax({
					url: self.getInitUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						if (reponseData.data.islogin == 0) {
							self.$router.push("/login");
							return;
						}
						if (reponseData.data.agent == 0) {
							self.$router.push("/user");
						} else {
							self.$router.push("/user/agent");
						}
					},
					error: function() {
						self.$toast("system error");
					}
				});
			}
		}
	};
</script>

<style scoped>
	.modal {
		position: fixed;
		bottom: 75px;
		width: 100%;
		z-index: 800;
	}

	.modal-content {
		background-color: #fff;
		box-shadow: 0px 0px 15px #999999;
		padding: 0;
		margin: 0 15px;
		padding: 20px 10px 10px 10px;
		border-radius: 4px;
		text-align: center;
	}

	.modal .van-icon {
		color: #888;
		margin-top: 12px;
	}

	.modal ul {
		display: flex;
		justify-content: space-around;
	}

	.modal ul li {
		width: 25%;
		text-align: center;
		font-size: 14px;
		color: #666;
	}

	.modal ul li img {
		max-width: 50px;
	}

	.footmenu {
		background-color: #fff;
		position: fixed;
		bottom: 0;
		z-index: 600;
		width: 100%;
		box-shadow: 0 -2px 6px rgba(200, 200, 200, 0.2);
		height: 50px;
	}

	.footmenu ul {
		display: flex;
		justify-content: space-around;
		align-items: center;
		padding: 0 0;
	}

	.footmenu ul li {
		display: flex;
		flex-flow: column;
		font-size: 12px;
		color: #7d7e80;
		justify-content: center;
		align-items: center;
		height: 45px;
		position: relative;
	}

	.footmenu ul li .plus {
		background-image: linear-gradient(90deg, #ef8732, #f56229);
		height: 36px;
		width: 36px;
		border: #fff 6px solid;
		box-shadow: 0 -2px 6px rgba(200, 200, 200, 0.2);
		border-radius: 100%;
		color: #fff;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		bottom: 12px;
	}

	.footmenu ul li .plus-txt {
		position: absolute;
		width: 60px;
		text-align: center;
		bottom: 0;
	}

	.ai-boot {	 
		width: 64px;
		height: 64px;
		position: fixed;
		bottom: 120px;
		right: 15px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
	}
	.ai-boot  img{
		width: 64px;
		height: 64px;
	}
</style>>